import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockListLayer from "../components/StockListLayer";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";

const StockListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchInvoices = async () => {
    const locationId = localStorage.getItem('locationID');
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user) {
      window.location.href = '/sign-in';
    } else {
      try {
        const response = await fetch(API_URL + `/api/invoice/stock/fetch?locationId=${locationId}`, {
          method: "GET",
          headers: { "Accept": "*/*", "Content-Type": "application/json" }
        });
        const json = await response.json();
        setData(json.stock || []);
      } catch (err) {
        console.error("Error fetching stock:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Stock - List" />

        {loading ? (
          <div className="text-center mt-4">
            <Spinner />
          </div>
        ) : (
          // Always render StockListLayer — the Sync button must always be visible
          <StockListLayer jobsData={data} />
        )}
      </MasterLayout>
    </>
  );
};

export default StockListPage;

